if (!customElements.get('desktop-drawer')) {
  customElements.define('desktop-drawer', class DesktopDrawer extends HTMLElement {
    connectedCallback() {
      this._details = this.querySelector('details');
      this._summary = this.querySelector('summary');

      if (!this._details || !this._summary) return;

      this._summary.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleDrawer();
      });

      const closeBtn = this.querySelector('.js-btn-close-drawer');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => this.closeDrawer());
      }

      const input = this.querySelector('.js-drawer-focus-element');
      if (input) {
        input.removeAttribute('readonly');
        input.removeAttribute('disabled');
        input.style.pointerEvents = 'auto';
        input.style.userSelect = 'text';
        input.style.webkitUserSelect = 'text';
      }
    }

    toggleDrawer() {
      this._details.hasAttribute('open') ? this.closeDrawer() : this.openDrawer();
    }

    openDrawer() {
      this._details.setAttribute('open', '');
      document.body.classList.add('menu-opening');
    }

    closeDrawer() {
      this._details.removeAttribute('open');
      document.body.classList.remove('menu-opening');
    }
  });
}
